module.exports = __webpack_public_path__ + "static/media/13.ec6945d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hats/13.png
// module id = 724
// module chunks = 0